
<template>
	<div class="upperWrap Inquiry" id="Inquiry">
		<div class="subVisWrap" style="">
		<div class="innerWrap">
				<div class="form">
				<div class="inqForm al">
					<h3 class="pb20"><br><span class="b ">도입 문의 및 체험신청</span></h3>
						<div class="formBox">
							<label>신청인 정보 <span class="pointC">*</span></label>
							<input type="text" class="nameInput" placeholder="이름" v-model="params.reqNm" maxlength="100">
							<input type="text" class="telInput" placeholder="연락처" @keyup="noSpace($event, 'reqTel')" v-model="params.reqTel" maxlength="50">
						</div>
						<div class="formBox">
							<label>단지명 <span class="pointC">*</span></label>
							<input type="text" placeholder="아파트(단지)명을 입력하세요." v-model="params.aptNm" maxlength="100">
						</div>
						<div class="formBox">
							<label>단지 주소 <span class="pointC">*</span></label>
							<input type="text" placeholder="주소 찾기로 단지 주소를 선택하세요." readonly :value="params.location" :title="params.location" @click="openPostcode">
								<span class="btn btnBasic type02 sm postBtn" @click="openPostcode">주소 찾기</span>
						</div>
						<div class="formBox">
							<label>세대 수 <span class="pointC">*</span></label>
							<input type="text" inputmode="numeric" placeholder="세대 수" :value="params.houseCnt" @input="onHouseCnt" maxlength="7">
						</div>
						<div class="formBox">
							<label>Email <span class="pointC">*</span></label>
							<input type="text" placeholder="문서를 수신받을 이메일 주소를 입력하세요." @keyup="noSpace($event, 'reqEmail')" v-model="params.reqEmail" maxlength="100">
						</div>	
						<div class="formBox">
							<label>문의 내용</label>							
							 <textarea cols="30" rows="5" v-model="params.reqContent" maxlength="6000"></textarea>
						</div>
						<div class="formBox">
							<label>체험신청서 업로드 <span class="pointC">※ 체험을 원하시면 필수 업로드하세요</span></label>
							 <span class="fileWrap vm" style="">
								<input style="" type="text" class="w70p filename" readonly :value="params.file ? params.file.name : ''">
								
								 <span class="btn btnBasic type02 sm" style="" onclick="$(this).next('input').click(); ">찾아보기</span>
								 <input name="File1" class="btnUpload" style="position:absolute;left:-9999999px;" id="File1" ref="fileInput" @change="selectFile" type="file" >
							</span>
						</div>
						<div class="formBox">
							<label class="fa-ckbox mr20"><input type="checkbox" v-model="params.check"><span class="pl10 vb"><span class="pointC">*</span> 당사의 개인정보 수집 및 이용에 동의합니다. <a href="javascript:;" onclick="$('#infoPop').toggle();" style="text-decoration: underline; color:#aaa; font-size: 0.8em;">(자세히 보기)</a></span></label>
				<div id="infoPop" style="display: none;">1. 정보수집 이용 기관명 : (주)디엑스플랫폼  <br> 2. 정보 수집, 이용범위와 사용목적 <br>         
				 * 수집 : 기관 및 단지정보, 신청자명, 연락처, 이메일, 세대수, 방문경로 <br> * 사용목적 : 프로그램 사용 신청 및 계약관련 <br>3. 수집 및 이용기간 : 해당 사업 종료시 까지 <br>4. 그 밖의 사항은 개인정보 취급방침을 준수합니다.                
				</div>
				</div>
            
						<div class="ac pt25">
							<a href="#" @click.prevent="onSubmit" class="btn btnBasic ac">{{ sending ? '신청 중' : '상담 신청하기' }}</a>
					</div>
				</div>
				<div class="inqForm type02">
					<h3 class="pb20">체험신청서 다운로드</h3>
					<p class="pb20">아래 체험신청서를  다운받은 후 <br> 작성하여 좌측 폼에 업로드하시면 <br> 체험등록에 대해 안내해드립니다.</p>
					<a href="/files/APTOK_DOC_experience_202201.zip" class="btn btnLineBasic ac" download><i class="fas fa-file-word mr10"></i>신청서 <span class="mOff">다운로드</span></a>
				</div>
				<div class="inqForm type02">
					<h3 class="pb20">계약서 다운로드</h3>
					<p class="pb20">계약서를 작성하여 <br><span class="pointC b">support@aprocni.com</span> 으로 보내주시면 <br> 계약 진행을 도와드립니다.</p>
					<a href="#" class="btn btnLineBasic ac"><i class="fas fa-file-word mr10"></i>계약서<span class="mOff"> 다운로드</span></a>
				</div>
			</div>
		</div>
		</div>
		<div v-if="postOpen" class="postLayer" @click.self="postOpen = false">
			<div class="postBox">
				<div class="postHead">주소 찾기 <span class="postClose" @click="postOpen = false">&times;</span></div>
				<div ref="postEl" class="postBody"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { nextTick, reactive, ref } from 'vue'
import axios from 'axios';

const POSTCODE_URL = 'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
const MAX_FILE_SIZE = 1024 * 1024; // 스프링 기본 업로드 한도 1MB. 체험신청서는 수백 KB 다
const MAX_LOCATION = 100;          // p_sys_demo_request.location

const emptyParams = () => ({
	aptNm : '',
	location : '',
	houseCnt : '',
	reqNm : '',
	reqTel : '',
	reqEmail : '',
	reqContent : '',
	check : false,
	file : null
});

const alertInfo = (text) => window.Alert.info(text);

export default {
  name: 'Inquiry',

  setup(){
	const params = reactive(emptyParams());
	const sending = ref(false);
	const postOpen = ref(false);
	const postEl = ref(null);
	const fileInput = ref(null);

	const selectFile = (event) => {
		const file = event.target.files[0] || null;
		if(file && file.size > MAX_FILE_SIZE){
			alertInfo("첨부 파일은 1MB 이하로 올려 주세요.");
			event.target.value = '';
			params.file = null;
			return;
		}
		params.file = file;
	}

	// admin commonUtil.js openDaumPostcode 와 같은 조합 — 도로명 주소 뒤에 (법정동, 건물명)
	const fullAddress = (data) => {
		if(data.addressType !== 'R') return data.address;
		const extra = [data.bname, data.buildingName].filter(Boolean).join(', ');
		return data.address + (extra ? ' (' + extra + ')' : '');
	}

	const embedPostcode = async () => {
		postOpen.value = true;
		await nextTick();
		new window.kakao.Postcode({
			width : '100%',
			height : '100%',
			oncomplete : (data) => {
				const address = fullAddress(data);
				postOpen.value = false;
				if(address.length > MAX_LOCATION){
					alertInfo("주소가 너무 깁니다. 건물명이 없는 다른 결과를 골라 주세요.");
					return;
				}
				params.location = address;
			}
		}).embed(postEl.value);
	}

	const openPostcode = () => {
		if(window.kakao && window.kakao.Postcode){
			embedPostcode();
			return;
		}
		const script = document.createElement('script');
		script.src = POSTCODE_URL;
		script.onload = embedPostcode;
		script.onerror = () => {
			script.remove();
			alertInfo("주소 검색을 불러오지 못했습니다. 잠시 뒤 다시 눌러 주세요.");
		};
		document.head.appendChild(script);
	}

	const onHouseCnt = (event) => {
		const digits = event.target.value.replace(/[^0-9]/g, '').replace(/^0+/, '');
		event.target.value = digits;
		params.houseCnt = digits;
	}

	const validationMessage = () => {
		if(!params.check) return "개인정보 수집 및 이용에 동의 후 상담 신청이 가능합니다.";
		if(params.reqNm.trim() == "") return "신청인 이름을 입력해 주세요.";
		if(params.reqTel == "") return "신청인 연락처를 입력해 주세요.";
		if(!/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(params.reqTel.replaceAll("-",""))) return "유효하지 않은 전화번호 형식입니다.";
		if(params.aptNm.trim() == "") return "단지명을 입력해 주세요.";
		if(params.location == "") return "단지 주소를 찾아 주세요.";
		if(params.houseCnt == "") return "세대 수를 입력해 주세요.";
		if(params.reqEmail == "") return "문서를 수신받을 이메일을 입력해 주세요.";
		if(!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(params.reqEmail)) return "유효하지 않은 이메일 형식입니다.";
		return null;
	}

	const onSubmit = async() => {
		if(sending.value) return;

		const message = validationMessage();
		if(message){
			alertInfo(message);
			return;
		}

		const formData = new FormData();
		if(params.file) formData.append('file', params.file);
		formData.append('params', JSON.stringify({
			aptNm : params.aptNm.trim(),
			location : params.location,
			houseCnt : Number(params.houseCnt),
			reqNm : params.reqNm.trim(),
			reqTel : params.reqTel,
			reqEmail : params.reqEmail,
			reqContent : params.reqContent
		}));

		sending.value = true;
		try {
			const res = await axios.post("/api/regist", formData);
			if(res.data.status != "OK") throw new Error(res.data.status);

			Object.assign(params, emptyParams());
			if(fileInput.value) fileInput.value.value = '';
			alertInfo("상담 신청이 완료되었습니다.");
		} catch (e) {
			// 서버가 알려 준 문구가 있으면 그대로, 없으면(연결 실패 등) 다시 시도 안내
			const data = e.response && e.response.data;
			alertInfo((data && data.message) || "잠시 후 다시 시도해 주세요.");
		} finally {
			sending.value = false;
		}
	}

	const noSpace = (event, key) => {
		const value = event.target.value;
		if(/\s/.test(value)){
			params[key] = value.replace(/\s/g, '');
			alertInfo("공백을 사용할 수 없습니다.");
		}
	}

	return {params, sending, postOpen, postEl, fileInput, selectFile, openPostcode, onHouseCnt, onSubmit, noSpace};

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.postBtn {display:block; width:100%; margin-top:8px; cursor:pointer;}
.postLayer {position:fixed; top:0; right:0; bottom:0; left:0; z-index:1000; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center;}
.postBox {width:500px; max-width:calc(100% - 32px); height:560px; max-height:calc(100% - 32px); background:#fff; border-radius:10px; overflow:hidden; display:flex; flex-direction:column;}
.postHead {flex:none; padding:14px 20px; font-size:1.2rem; font-weight:bold; border-bottom:1px solid #eee;}
.postClose {float:right; cursor:pointer; font-size:1.5rem; line-height:1;}
.postBody {flex:1; min-height:0;}
</style>

